import { apiMockSwitcher } from 'APIPackage/MainModule/mock/apiMockSwitcher';

import { getServiceBaseURL } from '../../MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from '../../MainModule/enums/APIServiceEnum';
import { handleResponse } from '../../MainModule/common/handleResponse';
import { IKnmActType } from '../interfaces/IKnmActType';

export async function fetchKnmActTypes(): Promise<IKnmActType[]> {
  const url = `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/knm-act-type`;
  const mockData = apiMockSwitcher<IKnmActType[]>(url, 'GET');

  if (mockData) return mockData;

  return fetch(url, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(handleResponse);
}
